export default function Subtitle({ text, size = 'big', color = 'gray', position = 'left' }) {
  const baseClasses = 'font-bold';
  const variants = {
    big: '',
    surveySectionBig: 'text-xl sm:text-xl',
    surveyQuestionBig: 'text-base sm:text-base',
    small: 'text-sm',
  };

  const positions = {
    left: '',
    center: 'text-center',
  };

  const colorClasses = {
    red: 'text-red',
    green: 'text-green',
    yellow: 'text-yellow',
    blue: 'text-blue',
    gray: 'text-subtitle-light dark:text-subtitle-dark',
  };

  return (
    <h2 className={`${baseClasses} ${variants[size]} ${positions[position]} ${colorClasses[color]}`}>
      {text}
    </h2>
  );
}
